<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="baseForm">
    <el-form
      class="el-form-submit"
      :model="model"
      :rules="rules"
      :label-width="labelWidth"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <el-row :gutter="gutter">
        <el-col
          v-for="item in formOptionsFilter"
          :key="item.prop"
          :span="item.span || itemSpan"
          :offset="item.offset || itemOffset"
        >
          <el-form-item
            :label="item.label"
            :prop="item.prop"
            :rules="item.rules"
            :label-width="item.isTitle ? '100%' : labelWidth"
            :class="[item.itemAttrs ? item.itemAttrs.class : '', item.isTitle ? 'el-form-item--title' : '' ]"
            v-bind="item.itemAttrs"
          >
            <base-title v-if="item.isTitle" slot="label" :title="item.label" v-bind="item.titleAttrs" />
            <span v-if="item.labelSlot" slot="label" v-html="item.label" />
            <template v-if="item.popoverContent" slot="label">
              <span v-html="item.label" />
              <el-popover
                placement="top"
                :width="item.popoverWidth || 350"
                trigger="hover"
              >
                <div slot="default" v-html="item.popoverContent" />
                <i slot="reference" class="el-icon-warning-outline" />
              </el-popover>
              ：
            </template>
            <template v-if="item.prop && $scopedSlots[item.prop]">
              <slot :name="item.prop" :item="item" :model="model" :prop="item.prop" />
            </template>
            <component
              :is="item.component.name"
              v-else-if="item.component && item.component.name"
              v-model="model[item.prop]"
              v-bind="getAttrs(item)"
              v-on="getEvents(item)"
            >
              <template v-for="slot in item.component.slots" v-slot:[slot.name]>
                <div :key="slot.name" v-html="slot.content" />
              </template>
            </component>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { isFunction } from 'lodash'
export default {
  name: 'BaseForm',
  components: {},
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    rules: {
      type: Object,
      default: () => {}
    },
    formOptions: {
      type: Array,
      default: () => []
    },
    gutter: {
      type: Number,
      default: () => 0
    },
    itemSpan: {
      type: [Number, String],
      default: 8
    },
    itemOffset: {
      type: [Number, String],
      default: 0
    },
    labelWidth: {
      type: String,
      default: '80px'
    }
  },
  computed: {
    formOptionsFilter() {
      return this.formOptions.filter(item => !item.hidden)
    }
  },
  methods: {
    getAttrs(item) {
      const { component, prop } = item
      const { attrs } = component
      if (isFunction(attrs)) {
        return attrs(prop, this.model) || {}
      } else {
        return attrs
      }
    },
    getEvents(item) {
      const { component } = item
      const { listeners } = component
      return listeners || {}
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item--title {
  margin-bottom: 0 !important;
  .el-form-item__label {
    text-align: left;
  }
}
</style>
